module.exports = __webpack_public_path__ + "static/product-page-3b4839715f98b411f9e6c178145dd802.jpg";